import React, { memo, useMemo } from "react";

const FormField = memo(({ field, isEdit, handleFieldChange, isMultiple = false }) => {
    const { label, name, value, placeholder, type, error, options, helperText } = field;

    const selectOptions = useMemo(() => {
        if (!options || type !== "select") return null;

        return options.map((option) => (
            <option key={option} value={option}>
                {option}
            </option>
        ));
    }, [options, type]);

    return (
        <div>
            <span className="font-medium text-md text-grey-900">{label}</span>
            {!isEdit ? (
                <p className="text-sm font-normal text-grey-700">{value}</p>
            ) : type === "select" ? (
                <div className="relative">
                    <select
                        value={value}
                        onChange={(e) => handleFieldChange(name, e.target.value)}
                        className="w-full p-2 mt-2 font-normal border rounded-lg appearance-none bg-grey-25 text-grey-700 placeholder-grey-500 border-grey-300"
                    >
                        <option value="">Select</option>
                        {selectOptions}
                    </select>
                </div>
            ) : (
                <>
                    {isMultiple ? (
                        <textarea
                            type={type}
                            value={value}
                            onChange={(e) => handleFieldChange(name, e.target.value)}
                            className={`w-full p-3 mt-2 font-normal border rounded-lg text-grey-700 placeholder-grey-500 bg-grey-25 ${error ? "border-red-500" : "border-grey-300"
                                }`}
                            placeholder={placeholder}
                            rows={4}
                        />
                    ) : (
                        <input
                            type={type}
                            value={value}
                            onChange={(e) => handleFieldChange(name, e.target.value)}
                            className={`w-full !h-[44px] p-3 mt-2 font-normal border rounded-lg text-grey-700 placeholder-grey-500 bg-grey-25 ${error ? "border-red-500" : "border-grey-300"
                                }`}
                            placeholder={placeholder}
                        />
                    )}
                    {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
                    {helperText && !error && <p className="mt-1 text-xs text-grey-500">{helperText}</p>}
                </>
            )}
        </div>
    );
});

FormField.displayName = "FormField";

export default FormField;